import React from "react";
import { Helmet } from "react-helmet-async";
const Seo = ({
  title,
  description,
  name,
  type,
  yahooseeker,
  YahooSeeker,
  msnbot,
  googlebot,
  searchengines,
  keywords,
  canonical,
  schema,
}) => {
  // Convert the data to a JSON-LD string

  return (
    <>
      <Helmet>
        {/* Standard metadata tags */}
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        {/* End standard metadata tags */}
        {/* Facebook tags */}
        <meta property="og:type" content={type || "website"} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {canonical && <meta property="og:url" content={canonical} />}
        <meta name="YahooSeeker" content={YahooSeeker || yahooseeker || "INDEX, FOLLOW"} />
        <meta name="msnbot" content={msnbot || "INDEX, FOLLOW"} />
        <meta name="googlebot" content={googlebot || "INDEX, FOLLOW"} />
        <meta name="search engines" content={searchengines || "ALL"} />
        {/* Canonical link tag */}
        {canonical && <link rel="canonical" href={canonical} />}
        {/* End Facebook tags */}
        {/* Include your Schema.org script */}
        {/* JSON-LD Schema */}
        {schema && (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        )}
      </Helmet>
    </>
  );
};

export default Seo;
